import React from 'react';
import { ForgeIcon, ForgeInlineMessage } from '@tylertech/forge-react';
import { I18n } from 'common/visualizations';
import { useError } from '../../context/errorContext';

const scope = 'shared.components.schedule_send_report.modal.inline_message';

const ErrorInlineMessage = () => {
  const { errorMessage, error } = useError();

  // Add additional cases here for using the proper translations for different error messages
  const errorTranslationKey = errorMessage === 'duplicate' ? errorMessage : 'default';

  return (
    <ForgeInlineMessage theme="error" data-testid="error-inline-message">
      <ForgeIcon slot="icon" name="info"></ForgeIcon>
      <p slot="title">{I18n.t('error.title', { scope })}</p>
      <p>{I18n.t(`error.${errorTranslationKey}`, { scope, action: error?.action })}</p>
    </ForgeInlineMessage>
  );
};

export default ErrorInlineMessage;
